module.exports = __webpack_public_path__ + "img/delete.181957aa.svg";